import React, {Component} from 'react';



import Paper from '@mui/material/Paper';
import LoginForm from './LoginForm';
import LoginFooter from './LoginFooter';
import LoginCarousel from './LoginCarousel';
import { CenterGrid } from '../layout';
import { Box, type Theme } from '@mui/material';

const s:any = {
  rootbox:{
    position: 'relative',
    height: '100vh',
  },
  gridbox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)'
  },
  main: (theme:Theme)=>({
    display: 'flex',
    justifyContent: 'center',
    backgroundColor:theme.palette.primary.main,
    borderRadius: 15,
  }),
};

class LoginMain extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      count: 0,
    };
  }


  render() {
    const {home,apptheme,logincontext,onMessage,classes,onGenerateForm} = this.props;

    return (
      <Box sx={{...s.rootbox}}>
        <Box sx={{...s.gridbox}}>
          <CenterGrid>
            <Paper elevation={3} square={false} sx={{...s.main}}>
              <LoginCarousel onMessage={onMessage} />
              <LoginForm home={home} apptheme={apptheme} logincontext={logincontext} onMessage={onMessage} onGenerateForm={onGenerateForm} />
            </Paper>
            <LoginFooter home={home} apptheme={apptheme} onMessage={onMessage} />
          </CenterGrid>
        </Box>
      </Box>
    );
  }
}

export default LoginMain;
